// 先天健康状态模块
// wylq（五运六气）已在 pipeline.parseBase 中完成 JSON.parse
// 当前无额外清洗需求，保留该文件作为扩展入口
export default function transform(/* data */) {
    // no-op
}
